var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "56px",
    height: "56px",
    viewBox: "0 0 256.00 256.00",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    transform: "matrix(1, 0, 0, 1, 0, 0)rotate(0)",
    strokeWidth: 7.68,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,68a8,8,0,1,1-8-8A7.99993,7.99993,0,0,1,172,68Zm-55.07324,65.43945-40,48a4.00015,4.00015,0,0,0,6.14648,5.1211l40-48a4.00015,4.00015,0,1,0-6.14648-5.1211ZM236,80a3.9985,3.9985,0,0,1-1.78125,3.32812L212,98.14062V120A100.113,100.113,0,0,1,112,220H8a3.99977,3.99977,0,0,1-3.123-6.499L100,94.59668V76A56.00814,56.00814,0,0,1,209.794,60.3877l24.4248,16.28418A3.99914,3.99914,0,0,1,236,80Zm-11.21094,0-20.6748-13.78418a3.99981,3.99981,0,0,1-1.65235-2.32227A48.00774,48.00774,0,0,0,108,76V96a4.00184,4.00184,0,0,1-.87695,2.499L16.32227,212H112a92.10447,92.10447,0,0,0,92-92V96a3.9985,3.9985,0,0,1,1.78125-3.32812Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/Bird.3e3dcc3757dceb721b3507dffe6c34c0.svg";
export { ForwardRef as ReactComponent };